<nz-range-picker
  [(ngModel)]="dates"
  [nzFormat]="dateFormat()"
  [nzAllowClear]="allowClear"
  [nzDisabledDate]="disabledDate"
  nzDropdownClassName="customCalendar"
></nz-range-picker>
